import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './dashboard/components/home/home.component';
import { UserViewComponent } from './user/user-view/user-view.component';
import { UserManagementComponent } from './user/management/user-management.component';
import { adminGuard } from './core/services/auth/admin.guard';
import { authGuard } from './core/services/auth/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'dashboard', canActivate: [authGuard], loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'user-view', canActivate: [authGuard], component: UserViewComponent, data: { title: 'Profile Control Panel', module: 'IAM' } },
  {
    path: 'user-management',
    component: UserManagementComponent,
    canActivate: [adminGuard],
    data: { title: 'User Directory & Access Controls' }
  },
  { path: 'home', canActivate: [authGuard], component: HomeComponent, data: { title: 'Operations Dashboard' } },
  { path: 'hrm', canActivate: [authGuard], loadChildren: () => import('./hrm/hrm.module').then(m => m.HrmModule) },
  { path: 'accounts', canActivate: [authGuard], loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule) },
  { path: 'order', canActivate: [authGuard], loadChildren: () => import('./order/order.module').then(m => m.OrderModule) },
  { path: 'work', canActivate: [authGuard], loadChildren: () => import('./production/work-report.module').then(m => m.WorkReportModule) },
  { path: 'manage', canActivate: [authGuard], loadChildren: () => import('./manage/manage.module').then(m => m.ManageModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


